import { ChevronLeft } from '@aktiia/design-system';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { usePatient } from '../../../contexts';
import { Device, ModalName } from '../../../enums';
import { useOpenModal } from '../../../features/modals';
import { useDateRangeText, useTableHeaders, useTableRows } from '../../../features/physiological-data';
import { Button } from '../../common';
import { Table } from '../table';

export const DetailedBpCuffList = () => {
  const { t } = useTranslation();
  const range = useDateRangeText();
  const rows = useTableRows(Device.CUFF);
  const headers = useTableHeaders(Device.CUFF);
  const openLearnMoreAboutCuffModal = useOpenModal(ModalName.LEAR_MORE_ABOUT_CUFF);
  const { visibleTables, toggleVisibleTable } = usePatient();
  const isTableVisible = useMemo(() => {
    return visibleTables.includes(Device.CUFF);
  }, [visibleTables]);

  if (!rows.length) {
    return <></>;
  }

  return (
    <div id="detailedBpCuffList">
      <span className="flex typography-heading-2 text-text-primary pt-6 mb-2">
        {t('patient.title.cuffMeasurements', { range })}
      </span>
      <div className="buttonsContainer detailedBpCuffListSubHeader flex items-center">
        <span className="typography-paragraph-3 text-text-secondary">{t('patient.label.cuffMeasurements')}</span>
        <Button
          text={t('patient.button.more')}
          size="sm"
          type="tertiary"
          className="learn-more-btn pdf-hide ml-2"
          onClick={() => openLearnMoreAboutCuffModal()}
        />
        <Button
          text={t(`patient.button.${isTableVisible ? 'hide' : 'show'}`)}
          size="sm"
          type="tertiary"
          className="learn-more-btn pdf-hide ml-auto"
          onClick={() => toggleVisibleTable(Device.CUFF)}
          leftIcon={
            <ChevronLeft
              className={`chevron scale-75 transition duration-150 ease-out ${
                isTableVisible ? 'rotate-90' : '-rotate-90'
              }`}
            />
          }
        />
      </div>
      <Table
        id="detailedBpCuffTable"
        className={!isTableVisible ? 'hidden' : ''}
        rows={[...rows].reverse()}
        header={headers}
      />
    </div>
  );
};
